import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
} from "react-bootstrap";

import GeneralForm from "./GeneralForm";
import ShippingDetails from "./ShippingDetails";
import Stepper from "../../components/Stepper";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
} from "@tabler/icons-react";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, roundToMoney } from "../../constant/_constant";
import { toast } from "react-toastify";
import { format } from "date-fns";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ProductDetails from "./ProductDetails";
import FileUpload from "../../components/Attachment/Attachment";
import NotesSection from "./NotesSection";
import InvestigationForm from "./InvestigationForm";
import ResolutionForm from "./ResolutionForm";
import FollowupForm from "./FollowupForm";
import CommunicationTab from "./CommunicationTab";
import useIdleLogout from "../../hooks/useIdleLogout";
import { trimTrailingZeros } from "../../utils/_helpers";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

const PORT = process.env.REACT_APP_BASE_URL;

function CreateRma() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [initialVal, setInitialVal] = useState(1);
  const [serverErr, setServerErr] = useState([]);
  const [show, setShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rmaDataFetched, setRmaDataFetched] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [rfqDataFetchedcopy, setRfqDataFetchedcopy] = useState(false);
  const [formId, setFormId] = useState(null);
  const [singleRmaQuantity, setSingleRmaQuantity] = useState([]);
  const [searchDebounce, setSearchDebounce] = useState({
    searchName: "",
    searchEmail: "",
  });
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });

  console.log("singleRmaQuantity", singleRmaQuantity);
  useIdleLogout();

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { rma_id } = useParams();

  const schema = yup.object().shape({
    notes: yup.array().of(
      yup.object().shape({
        section: yup.string().required("Section is required"),
        notesdata: yup.array().of(
          yup.object().shape({
            note: yup.string().required("Note cannot be blank"),
          }),
        ),
      }),
    ),

    // step 1
    rma_id: yup.string().required("RMA ID is required"),
    manufacturer_id: yup.string().nullable(),
    publishedDate: yup.date().required("Published Date is required"),
    // estimatedDate: yup.date().required("Estimated Return Date is required"),
    estimatedDate: yup
      .date()
      .optional()
      .typeError("Invalid date")

    // .test(
    //   "is-less-than-actual",
    //   "Estimated Date must be less than Actual Date",
    //   function (value) {
    //     const actualDate = this.parent.actualDate;
    //     if (value && actualDate) {
    //       return new Date(value) <= new Date(actualDate);
    //     }
    //     return true; // If actualDate not set yet, skip
    //   },
    // )
    ,

    // actualDate: yup.date().required("Actual Return Date is required"),
    actualDate: yup
      .date()
      .nullable("")
      .typeError("Invalid date")

    // .test(
    //   "is-greater-than-estimate",
    //   "Actual Date must be greater than Estimated Date",
    //   function (value) {
    //     const estimatedDate = this.parent.estimatedDate;
    //     if (value && estimatedDate) {
    //       return new Date(value) >= new Date(estimatedDate);
    //     }
    //     return true; // If estimatedDate not set yet, skip
    //   },
    // )
    ,
    // actualDate: yup.date().optional(),
    orderId: yup.string().optional(),
    initialCause: yup.string().optional(""),
    purchaseOrder: yup.string().nullable(),
    organization_name: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(2, "Must be at least 2 character")
      .max(100, "Must be at most 100 characters"),

    rma_Description: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(5, "Must be at least 5 characters")
      .max(500, "Must be at most 500 characters"),
    // step 2
    // trackingID: yup.string().nullable(),
    trackingID: yup
      .string()
      .nullable()
      .test(
        "minLength",
        "Tracking ID must be at least 5 characters",
        function (value) {
          if (value === null || value === undefined || value === "")
            return true;
          return typeof value === "string" && value.length >= 5;
        },
      ),
    // trackingID: yup
    //   .string()
    //   .nullable()
    //   .test(
    //     "minLength",
    //     "Tracking ID must be at least 5 characters",
    //     function (value) {
    //       if (value === null || value === "") return true; // Allow nullable or empty
    //       return value.length >= 5;
    //     }
    //   ),
    shipping_method: yup.string().optional(),
    shipping_method_detail: yup.string().optional(),
    contractOfficerName: yup.string().required("Customer name is required"),
    contractOfficerEmail: yup
      .string()
      .required("Customer email is required")
      .email("Email must be a valid email address"),
    contractOfficerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // contractOfficerPhone: yup
    //   .string()
    //   .required("Customer phone number is required")
    //   .transform((value) => (value === "" ? null : value))
    //   .test("valid-phone", "Invalid phone number", (value) => {
    //     if (!value) {
    //       return true;
    //     }
    //     if (typeof value === "string" && value.trim() !== "") {
    //       return isValidPhoneNumber(value);
    //     }

    //     return false;
    //   }),
    contractOfficerAddress: yup
      .string()
      .required("Customer address is required"),

    shippingCustomerName: yup.string().nullable(),
    shippingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    shippingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // shippingCustomerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .test("valid-phone", "Invalid phone number", (value) => {
    //     if (!value) {
    //       return true;
    //     }
    //     if (typeof value === "string" && value.trim() !== "") {
    //       return isValidPhoneNumber(value);
    //     }
    //     return false;
    //   })
    //   .nullable(),
    shippingCustomerAddress: yup.string().nullable(),

    sales_lead_name: yup.string().required("Sales Lead Name is required"),
    sales_lead_email: yup
      .string()
      .email("Email must be a valid email address")
      .required("Sales Lead Email is required"),
    sales_lead_phone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .min(10, "Phone number must be at least 10 digits")
      .required("Sales Lead Phone is required"),
    notification_emails: yup.array().of(yup.string().email("Invalid email")),

    // products: yup.array().of(
    //   yup.object().shape({
    //     refund_qty: yup
    //       .number()
    //       .transform((value) => (value === "" ? undefined : value))
    //       .typeError("Return quantity is required.")
    //       .required("Return quantity is required.")
    //       .min(1, "Return quantity must be greater than 0.")
    //       .test(
    //         "refund-less-than-qty",
    //         "Return quantity cannot exceed quantity.",
    //         function (refund_qty) {
    //           const { qty } = this.parent;
    //           return refund_qty <= qty;
    //         }
    //       ),
    //   })
    // ),

    // qty: yup.string().required("Quantity is required."),

    // qty: yup
    //   .number()
    //   .transform((value) => (value === "" ? null : value))
    //   .typeError("Must be a number.")
    //   .required("Quantity is required.")
    //   .test("is-valid-number", "not nagetive.", (value) => {
    //     return value === null || (!isNaN(value) && value !== -1);
    //   })
    //   .min(1, "at least 1."),
  });

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User?.username || "CUSTOMER",
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  const onOrderIdError = (err) => {
    // reset({
    //   OrderID: getValues("orderId"),
    // });
    // console.log("error", err);
    // toast.error("The order with this Order ID does not exist.");
    // setValue("orderId", "");
  };

  const onOrderIdSuccess = (res) => {
    if (res?.data) {
      // if (
      //   res?.data?.status === "PENDING") {
      //   toast.error(
      //     "The order with this Order ID is either not yet completed or does not exist.",
      //   );
      //   setValue("orderId", "");
      //   setValue("trackingID", "");
      //   setValue("rmaType", "");
      //   setValue("manufacturer_id", null);
      //   setValue("organization_name", "");
      //   setValue("estimatedDate", null);
      //   setValue("actualDate", null);
      //   setValue("rma_Description", "");
      //   return;
      // }
      setValue("orderId", res?.data?.order_id ? res?.data?.order_id : null);
      // setValue("rma_id", res?.data?.rma_id ? res?.data?.rma_id : null);
      setValue(
        "trackingID",
        res?.data?.tracking_number ? res?.data?.tracking_number : null,
      );
      setValue("purchaseOrder", res?.data?.orderExtra?.purchase_order);
      setValue(
        "manufacturer_id",
        res?.data?.manufacturer_id ? res?.data?.manufacturer_id : null,
      );
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue(
        "estimatedDate",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "actualDate",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : null,
      );
      setValue("rma_Description", res?.data?.brief);

      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : "",
      );
      setValue(
        "contractOfficerName",
        res?.data?.orderKo?.name ? res?.data?.orderKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.orderKo?.email ? res?.data?.orderKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.orderKo?.phone ? res?.data?.orderKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.orderKo?.address ? res?.data?.orderKo?.address : "",
      );

      setValue(
        "shippingCustomerName",
        res?.data?.orderShipping?.name ? res?.data?.orderShipping?.name : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.orderShipping?.phone ? res?.data?.orderShipping?.phone : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.orderShipping?.email ? res?.data?.orderShipping?.email : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.orderShipping?.address
          ? res?.data?.orderShipping?.address
          : "",
      );
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );

      const products = (res?.data?.OrderProductSales || []).map((product) => ({
        is_selected: false,
        vendorName: product?.Vendor?.display_name || "",
        autoId: product?.auto_id || "",
        name: product?.name || "",
        sku_main: product?.sku_id || "",
        invoice_no: product?.sku_display_name || "",
        clin_id: product?.clin_id || "",
        prod_desc: product?.description || "",
        qty: product?.quantity || 0,
        unit_of_measure: product?.unit_of_measure || "EA",
        aspetto_price: trimTrailingZeros(product?.aspetto_price) || "",
        margin_percent: trimTrailingZeros(product?.margin_percent) || "",
        sku_price: trimTrailingZeros(product?.customer_price) || "",
        row_id: product?.id || "",
        mainQty: product?.quantity || 0,
      }));

      setValue("products", products);

      const emailsString = res?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);
      setValue(
        "totalCostBeforeMargin",
        res?.data?.total_cost_before_margin
          ? res?.data?.total_cost_before_margin
          : null,
      );
      setValue(
        "totalCostAfterMargin",
        res?.data?.total_cost_after_margin
          ? res?.data?.total_cost_after_margin
          : null,
      );
    }
  };

  const onOrderIdSuccessRma = (res) => {
    setOrderData(res?.data);
  };

  const { data: rma, postData: fetchSingleRma } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_RMA,
  );

  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES,
  );

  const { data: databyOrderId, postData: fetchDataByOrderID } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER,
  );

  const steps = [
    "General",
    "Billing & Shipping",
    "Attachments",
    "Notes",
    "Communication",
  ];

  useEffect(() => {
    if (rma_id && !rmaDataFetched) {
      fetchNotes(
        { module_id: rma_id, module_type: "RMA" },
        onSingleNotesSuccess,
      );
    }
  }, [rma_id, fetchNotes]);

  const onSingleRmaSuccess = (res) => {
    if (res?.data) {
      setValue("orderId", res?.data?.order_id ? res?.data?.order_id : "");
      setValue("rma_id", res?.data?.rma_id ? res?.data?.rma_id : null);
      setValue(
        "manufacturer_id",
        res?.data?.manufacturer_id ? res?.data?.manufacturer_id : null,
      );
      setValue("rmaType", res?.data?.rma_type ? res?.data?.rma_type : "");
      setValue("purchaseOrder", res?.data?.purchase_order || "");
      setValue("initialCause", res?.data?.initial_cause || "");
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue("custom_fields", res?.data?.custom_fields || []);
      setValue("rma_Description", res?.data?.brief);
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "actualDate",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimatedDate",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimateddelivery",
        res?.data?.estimated_delivery ? res?.data?.estimated_delivery : "",
      );
      setValue(
        "sales_lead_email",
        res?.data?.sales_lead_email ? res?.data?.sales_lead_email : "",
      );
      setValue(
        "sales_lead_phone",
        res?.data?.sales_lead_phone ? res?.data?.sales_lead_phone : "",
      );
      setValue(
        "sales_lead_name",
        res?.data?.sales_lead_name ? res?.data?.sales_lead_name : "",
      );
      setValue(
        "sales_lead_username",
        res?.data?.sales_lead_username ? res?.data?.sales_lead_username : "",
      );
      const emailsString = res?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);
      setValue("notifyEmails", res?.data?.notify_emails === 1 ? "1" : "0");
      setValue(
        "notifyEmailsVendor",
        res?.data?.notify_emails_vendor === 1 ? "1" : "0",
      );
      setValue(
        "payment_terms",
        res?.data?.payment_term ? res?.data?.payment_term : "",
      );
      if (res?.data?.attachment_id) {
        setFormId(res?.data?.attachment_id);
      }
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : "",
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : "",
      );
      setValue(
        "contractOfficerName",
        res?.data?.rmaKo?.name ? res?.data?.rmaKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.rmaKo?.email ? res?.data?.rmaKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.rmaKo?.phone ? res?.data?.rmaKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.rmaKo?.address ? res?.data?.rmaKo?.address : "",
      );
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );
      setValue(
        "shippingCustomerName",
        res?.data?.rmaShipping?.name ? res?.data?.rmaShipping?.name : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.rmaShipping?.email ? res?.data?.rmaShipping?.email : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.rmaShipping?.phone ? res?.data?.rmaShipping?.phone : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.rmaShipping?.address ? res?.data?.rmaShipping?.address : "",
      );

      res?.data?.RmaProducts?.forEach((product, index) => {
        setValue(
          `products.${index}.vendorName`,
          product?.Vendor?.display_name || "",
        );

        setValue(`products.${index}.row_id`, product?.raw_sku_id || "");

        setValue(`products.${index}.sku_main`, product?.sku_id || "");

        setValue(
          `products.${index}.invoice_no`,
          product?.sku_display_name || product?.sku_id || "",
        );

        setValue(`products.${index}.name`, product?.name || "");

        setValue(`products.${index}.prod_desc`, product?.description || "");

        setValue(`products.${index}.qty`, Number(product?.quantity || 0));

        setValue(
          `products.${index}.mainQty`,
          Number(product?.max_quantity || 0),
        );

        setValue(
          `products.${index}.sku_price`,
          Number(product?.customer_price || 0),
        );

        setValue(`products.${index}.autoId`, product?.order_product_ref || "");

        setValue(`products.${index}.is_selected`, !!product?.is_return);

        setValue(
          `products.${index}.total_price`,
          Number(product?.total_price || 0),
        );
      });

      setSingleRmaQuantity(res?.data?.RmaProducts || []);

      setValue(
        "totalCostAfterMargin",
        res?.data?.total_cost_after_margin
          ? res?.data?.total_cost_after_margin
          : null,
      );
      // setValue(
      //   "totalCostBeforeMargin",
      //   res?.data?.total_cost_before_margin
      //     ? res?.data?.total_cost_before_margin
      //     : null
      // );
      setInitialVal(0);

      // fetchDataByOrderID(
      //   { order_id: res?.data?.order_id },
      //   onOrderIdSuccessRma,
      // );
    }
  };

  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      // shippingCostEnabled: true,
      // taxEnabled: true,
      // tax: parseFloat("0.00").toFixed(2),
      // shippingCost: parseFloat("0.00").toFixed(2),
      // sales_lead_email: ,
      // sales_lead_name : ,
      // sales_lead_phone: ,
      notifyEmailsVendor: "0",
      notifyEmails: "0",
      rmaType: "EXCHANGE",
    },
  });

  const {
    handleSubmit,
    setError,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  console.log("errors", errors);

  const onError = (error) => {
    if (error?.errors) {
      const updatedErrors = {};
      Object.keys(error.errors).forEach((field) => {
        if (error.errors[field]?.message) {
          updatedErrors[field] = {
            message: error.errors[field]?.message,
          };
        }
      });

      setServerErr((prevState) => ({
        ...prevState,
        ...updatedErrors,
      }));
      setShow(true);
    }
    toast.error(error?.message);
  };

  const { isLoading: createLoading, postData: createRMA } = usePostRequest(
    API_ENDPOINTS.CREATE_RMA,
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES,
  );

  const { isLoading: UpdateLoading, postData: updateRMA } = usePostRequest(
    API_ENDPOINTS.UPDATE_RMA,
  );

  const formatPhone = (phone) => {
    if (!phone) return null;

    // Check if phone starts with '+'
    const startsWithPlus = phone.startsWith("+");

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");

    // Add '+' back if it was there
    return startsWithPlus ? `+${cleaned}` : cleaned ? cleaned : null;
  };

  const onSubmit = (data) => {
    const isUpdate = rma && rma_id;

    const custom_fieldsTransformed = data?.custom_fields?.map((fields) => {
      if (fields?.type === "Date") {
        return {
          type: fields?.type,
          value: moment(fields?.value).format("YYYY-MM-DD"),
          field_name: fields?.field_name,
        };
      } else {
        return {
          type: fields?.type,
          value: fields?.value,
          field_name: fields?.field_name,
        };
      }
    });

    const transformedProducts = data?.products?.map((product) => {
      const qty = Number(product?.qty || 0);
      const customerPrice = Number(product?.sku_price || 0);

      return {
        auto_id: product?.autoId ? product?.autoId : null,
        is_return: product?.is_selected ? true : false,
        vendor_name: product?.vendorName ? product?.vendorName : null,
        name: product?.name ? product?.name : null,
        sku_id: product?.sku_main ? product?.sku_main : null,
        sku_display_name: product?.invoice_no ? product?.invoice_no : null,
        description: product?.prod_desc?.trim() ? product.prod_desc : null,
        quantity: product?.qty ? Number(product?.qty) : 0,
        max_quantity: product?.mainQty ? Number(product?.mainQty) : 0,
        customer_price: product?.sku_price ? Number(product?.sku_price) : 0,
        raw_sku_id: product?.row_id ? product?.row_id : null,
        total_price: roundToMoney(qty * customerPrice),
      };
    });

    const payload = {
      rma_id: data?.rma_id ? data?.rma_id : null,
      manufacturer_id: data?.manufacturer_id ? data?.manufacturer_id : null,
      rma_type: data?.rmaType ? data?.rmaType : null,
      order_id: data?.orderId ? data?.orderId : null,
      initial_cause: data?.initialCause ? data?.initialCause : null,
      purchase_order: data?.purchaseOrder ? data?.purchaseOrder : null,
      // purchase_order: data?.purchaseOrder ? data?.purchaseOrder : null,
      // initial_cause: data?.initialCause ? data?.initialCause : null,
      published_date: moment(data?.publishedDate).format("YYYY-MM-DD"),
      estimated_date: moment(data?.estimatedDate).format("YYYY-MM-DD"),
      actual_date: data?.actualDate
        ? moment(data.actualDate).format("YYYY-MM-DD")
        : null,
      organization_name: data?.organization_name
        ? data?.organization_name
        : null,
      brief: data?.rma_Description ? data?.rma_Description : null,
      tracking_number: data?.trackingID ? data?.trackingID : null,
      shipping_method: data?.shipping_method ? data?.shipping_method : null,
      shipping_method_detail: data?.shipping_method_detail
        ? data?.shipping_method_detail
        : null,
      sales_lead_name: data?.sales_lead_name ? data?.sales_lead_name : null,
      sales_lead_email: data?.sales_lead_email ? data?.sales_lead_email : null,
      sales_lead_phone: data?.sales_lead_phone ? data?.sales_lead_phone : null,
      team_emails: data?.notification_emails?.length
        ? data.notification_emails.join(",")
        : null,
      notify_emails: data?.notifyEmails ? data?.notifyEmails : 0,
      notify_emails_vendor: data?.notifyEmailsVendor
        ? data?.notifyEmailsVendor
        : 0,
      ko_detail: {
        name: data?.contractOfficerName ? data?.contractOfficerName : null,
        email: data?.contractOfficerEmail ? data?.contractOfficerEmail : null,
        phone: formatPhone(data?.contractOfficerPhone),
        address: data?.contractOfficerAddress
          ? data?.contractOfficerAddress
          : null,
      },
      shipping_detail: {
        name: data?.shippingCustomerName ? data?.shippingCustomerName : null,
        email: data?.shippingCustomerEmail ? data?.shippingCustomerEmail : null,
        phone: formatPhone(data?.shippingCustomerPhone),
        // phone: data?.shippingCustomerPhone ? data?.shippingCustomerPhone : null,
        address: data?.shippingCustomerAddress
          ? data?.shippingCustomerAddress
          : null,
      },
      // custom_fields: custom_fieldsTransformed,
      // products: [...transformedProducts],
      products: Array.isArray(transformedProducts)
        ? [...transformedProducts]
        : [],

      attachment_id: formId,
      total_cost_after_margin: data?.totalCostAfterMargin
        ? Number(data?.totalCostAfterMargin)
        : null,
    };

    const onSuccess = (res) => {
      const notesPayload = {
        module_id: res?.rma_id,
        module_type: "RMA",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "RMA Created Successfully!",
        message: `Prepared by ${user?.username}. RMA ID is ${res.rma_id}.
         Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    const onSuccessUpdate = (res) => {
      const notesPayload = {
        module_id: res?.rma_id,
        module_type: "RMA",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "RMA Updated Successfully!",
        message: `Updated by ${user?.username}. RMA ID is ${res.rma_id}.
        Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    if (rma && rma_id) {
      updateRMA(payload, onSuccessUpdate, onError);
    } else {
      createRMA(payload, onSuccess, onError, API_ENDPOINTS.CREATE_RMA);
    }
  };

  useEffect(() => {
    if (rma_id && !rmaDataFetched) {
      fetchSingleRma({ rma_id }, onSingleRmaSuccess);
      setRmaDataFetched(true);
      setIsEditing(true);
    }
    // else {
    //   setInitialVal(0);
    // }
  }, [rma_id, rmaDataFetched, fetchSingleRma]);

  // useEffect(() => {
  //   if (rma_id && !rmaDataFetched) {
  //     fetchNotes(
  //       {
  //         module_id: rma_id,
  //         module_type: "RMA",
  //       },
  //       onSingleNotesSuccess
  //     );
  //   }
  // }, [rma_id, fetchNotes]);

  const handleOrderIDBlur = () => {
    const value = getValues("orderId");
    if (value.length > 0) {
      fetchDataByOrderID({ order_id: value }, onOrderIdSuccess, onOrderIdError);
    }
  };

  const handleStepChange = (type) => {
    if (type === "next") {
      const currentData = methods.getValues();

      console.log(currentData);

      const fieldsToValidate = getFieldsForCurrentStep(currentStep);
      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep((prev) => prev + 1);
        } else {
          console.log("Errors:", methods.formState.errors);
        }
      });
    } else {
      console.log("Errors:2", methods.formState.errors);
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleTabChange = (tabIndex) => {
    if (rma_id) {
      const fieldsToValidate = getFieldsForCurrentStep(currentStep);

      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep(tabIndex);
        } else {
          console.log("Validation failed for step:", currentStep);
        }
      });
    }
  };

  useEffect(() => {
    if (!rma_id) {
      reset();
      setCurrentStep(1);
    } else {
    }
  }, [rma_id, location.pathname]);

  const getFieldsForCurrentStep = (step, rma_id) => {
    switch (step) {
      case 1:
        return [
          "rma_id",
          "organization_name",
          "rma_Description",
          "publishedDate",
          "estimatedDate",
          "actualDate",
          "orderId",
          "initialCause",
        ];
      case 2:
        return [
          // "shipping_method",
          "shipping_method_detail",

          "contractOfficerName",
          "contractOfficerEmail",
          "contractOfficerPhone",
          "contractOfficerAddress",

          "shippingCustomerName",
          "shippingCustomerEmail",
          "shippingCustomerPhone",
          "shippingCustomerAddress",
        ];
      case 3:
        return ["products"];
      case 4:
        return [];
      case 5:
        return ["notes"];
      case 6:
        return [
          // "sales_lead_username",
          "sales_lead_phone",
          "sales_lead_email",
          "sales_lead_name",
        ];
      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  const rmaProductData = watch("products");

  console.log("the products are out ", singleRmaQuantity);
  console.log("rmaProductData", rmaProductData);

  if (rmaProductData) {
    console.log("the products are ", singleRmaQuantity);
    console.log("rmaProductData 2", rmaProductData);
  }

  /*useEffect(() => {
    
  }, [rmaProductData]);*/

  // useEffect(() => {
  //   if (orderData) {
  //     orderData?.OrderProductSales?.map((product, index) => {
  //       const matched = singleRmaQuantity.find(
  //         (item) => Number(item.order_product_ref) === Number(product.auto_id),
  //       );
  //       console.log("data 1", product);
  //       console.log("data 2", matched);

  //       setValue(
  //         `products[${index}].vendorName`,
  //         product?.Vendor?.display_name || "",
  //       );
  //       setValue(`products[${index}].invoice_no`, product?.sku_id || "");
  //       setValue(`products[${index}].prod_desc`, product?.description || "");

  //       console.log(
  //         "aaa",
  //         Number(product?.quantity || 0) -
  //           Number(product?.return_quantity || 0) +
  //           Number(matched?.quantity || 0),
  //       );

  //       let matchedValue =
  //         Number(product?.quantity || 0) -
  //         Number(product?.return_quantity || 0) +
  //         Number(matched?.quantity || 0);

  //       setValue(`products[${index}].qty`, matchedValue);
  //       // setValue(`products[${index}].qty`, product?.quantity || "");
  //       setValue(`products[${index}].sku_price`, product?.total_price || "");
  //       setValue(`products[${index}].autoId`, product?.auto_id || "");
  //     });

  //     // setValue(
  //     //   "totalCostAfterMargin",
  //     //   res?.data?.total_cost_after_margin
  //     //     ? res?.data?.total_cost_after_margin
  //     //     : null
  //     // );
  //   }
  // }, [orderData]);

  useEffect(() => {
    console.log("user order", user);
    if (user) {
      setValue("sales_lead_name", `${user?.first_name} ${user?.last_name}`);
      setValue("sales_lead_email", user?.email);
      setValue("sales_lead_phone", user?.phone);
      setValue("sales_lead_username", user?.username);
    }
  }, [user]);

  // useEffect(() => {
  //   if (!rma_id) {
  //     // reset();
  //     reset({
  //       ...getValues(),
  //       sales_lead_name: `${user?.first_name} ${user?.last_name}`,
  //       sales_lead_email: user?.email,
  //       sales_lead_phone: user?.phone,
  //       sales_lead_username: user?.username,
  //     });
  //     setCurrentStep(1);
  //   } else {
  //   }
  // }, [rma_id, location.pathname]);

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen({ ...isModalOpen, show: false }, navigate("/list-rma"))
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />

      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            {/* {!rma_id && ( */}
            <h2 className="page-title">
              {isEditing ? "Update RMA" : "Create RMA"}
            </h2>
            {/* )} */}
          </div>
        </div>
      </div>

      <Card>
        <Card.Body className="pt-3 pb-4 pt-md-5 pb-md-5">
          {/* <div className="page-header d-block d-sm-none text-center">
            <h2 className="page-title justify-content-center">Create RMA</h2>
          </div> */}
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onTabClick={rma_id ? handleTabChange : undefined}
          />
          <FormProvider
            {...methods}
            className=""
            onSubmit={methods.handleSubmit(onSubmit)}
          >
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
              {currentStep === 1 && (
                <GeneralForm
                  isEditing={isEditing}
                  onOrderIDBlur={handleOrderIDBlur}
                />
              )}
              {currentStep === 2 && <ShippingDetails initialVal={initialVal} />}
              {/* {currentStep === 3 && <ProductDetails />} */}
              {/* {currentStep === 4 && <InvestigationForm isEditing={isEditing} />} */}
              {currentStep === 3 && (
                <FileUpload moduleType={"RMA"} attachmnetid={formId} />
              )}
              {currentStep === 4 && <NotesSection />}
              {currentStep === 5 && <CommunicationTab />}
              {/* {currentStep === 6 && <CommunicationTab />} */}

              <div className="server_error">
                {show && (
                  <>
                    <Alert
                      variant="danger"
                      onClose={() => setShow(false)}
                      dismissible
                    >
                      <Alert.Heading>Validation Errors!</Alert.Heading>
                      {Object.keys(serverErr).map((field) => (
                        <p
                          key={field}
                          style={{ color: "red", marginBottom: "5px" }}
                        >
                          {serverErr[field]?.message}
                        </p>
                      ))}
                    </Alert>
                  </>
                )}
              </div>

              <div className="d-flex justify-content-center gap-3 mt-3">
                {currentStep > 1 && (
                  <Button
                    variant="outline-secondary"
                    onClick={() => handleStepChange("prev")}
                  >
                    <IconArrowNarrowLeftDashed /> Back
                  </Button>
                )}
                {currentStep < steps.length && (
                  <Button
                    variant="warning"
                    onClick={() => handleStepChange("next")}
                  >
                    Next <IconArrowNarrowRightDashed />
                  </Button>
                )}
                {rma_id
                  ? currentStep <= steps.length && (
                    <div className="d-flex">
                      <Button variant="success" type="submit">
                        {createLoading || UpdateLoading ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Update"
                        )}
                      </Button>
                    </div>
                  )
                  : null}
                {currentStep === 5 && (
                  <div className="d-flex">
                    <Button variant="warning" type="submit">
                      {createLoading || UpdateLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          </FormProvider>
        </Card.Body>
      </Card>
    </>
  );
}

export default CreateRma;
